import axios from "axios";
import { ProspectInterface } from "./prospect";

/**
 * Sanitizes an individual prospect payload.
 * Ensures all required fields are present with defaults for missing values.
 * @param {ProspectInterface} obj - The prospect to sanitize.
 * @returns {Record<string, any>} - A sanitized object.
 */
const sanitizeProspect = (obj: ProspectInterface): Record<string, any> => {
  return {
    CompanyName: obj.CompanyName ?? null,
    FirstName: obj.FirstName ?? null,
    LastName: obj.LastName ?? null,
    Phone: obj.Phone ?? null,
    Email: obj.Email ?? null,
    Address: obj.Address ?? null,
    City: obj.City ?? null,
    Province: obj.Province ?? null,
    PostalCode: obj.PostalCode ?? null,
    TitleDescription: obj.TitleDescription ?? null,
    SicCodeDescription: obj.SicCodeDescription ?? null,
    ConsultantId: obj.ConsultantId ?? null,
    ProspectStatusId: obj.ProspectStatusId ?? null,
    ProspectStatus: obj.ProspectStatus ?? null,
    Website: obj.Website ?? null,
    ProspectComment: obj.ProspectComment ?? null,
  };
};

/**
 * Sends a bulk import request for prospects to the backend API.
 * @param {ProspectInterface[]} payload - The list of prospects to import.
 * @returns {Promise<any>} - Resolves with the API response when successful.
 */
const bulkImportProspects = async (payload: ProspectInterface[]): Promise<any> => {
  try {
    // Sanitize the payload for each prospect
    const sanitizedPayload = payload.map(sanitizeProspect);

    console.log("DEBUG bulkImportProspects.ts: Sending sanitized payload to API:", JSON.stringify(sanitizedPayload));

    // Send the POST request
    const { data } = await axios({
      method: "POST",
      url: `/api/cantrackv3/BulkInsertProspect`,
      headers: { "Content-Type": "application/json;charset=UTF-8" },
      data: {payload: sanitizedPayload}, 
    });

    console.log("DEBUG bulkImportProspects.ts: Bulk import successful:", data);
    return data;
  } catch (error) {
    console.error("DEBUG bulkImportProspects.ts: Error during bulk import:", error);
    throw error;
  }
};

export default bulkImportProspects;
